module.exports = __webpack_public_path__ + "static/img/home-bg.20f6d0e1.png";